/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description getCanonicalPathFromFilters
 */

import { ListingAmenity } from '@zcode/enums'
import type { Filters } from '@zcode/state-type'
import { getPathFromFilters } from './getPathFromFilters'

export const getCanonicalPathFromFilters = (filters?: Filters) => {
  if (!filters) {
    return ''
  }

  let url = getPathFromFilters(filters)

  if (filters.listingAmenities?.includes(ListingAmenity.FURNISHED)) {
    url += '/furnished'
  }

  if (filters.shortTerm && !filters.longTerm) {
    url += '/short-term'
  }

  if (filters.maxDays === 1) {
    url += '/today'
  }

  return url
}
